<template>
  <div v-if="data">
    <div class="container">
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-3">
          <img :src="require( `../assets/img/novonordisk.png`)" alt="Logo" class="logo" />
          <h4 v-html="data.auth.authHeader"></h4>
          <div class="card">
            <div class="form-group">
              <label for="pwd" v-html="data.auth.pwdEnterLabel"></label>
              <input type="password" class="form-control" v-model="password"
                :disabled="$route.query.access && $route.query.access.length > 0"
                :placeholder="data.auth.pwdPlaceholder"
                @keyup.enter="enterKeyHandler()" id="pwd">
            </div>
            <div class="row">
                <div class="col-md-3"></div>
                <div class="col-md-6">
                  <div class="form-check">
                    <input id="pwd-check" type="checkbox"
                      class="form-check-input cursor-pointer" @change="showPwd()">
                    <label class="form-check-label cursor-pointer" v-if="showOrHide"
                      for="pwd-check" v-html="data.auth.pwdShowLabel"></label>
                    <label class="form-check-label cursor-pointer" v-if="!showOrHide"
                      for="pwd-check" v-html="data.auth.pwdHideLabel"></label>
                  </div>
                </div>
                <div class="col-sm"></div>
            </div>
            <div class="clearfix--min"></div>
            <button @click="auth()" :disabled="password.length < 3 || loginStarted"
              id="btn-ok" class="btn btn-consent btn-primary btn-md btn-block">OK</button>
          </div>
          <div class="card card-clear-pwd">
            <small>
              <span :class="loginStarted ? 'disabled' : ''" @click="clearPwd()" class="cursor-pointer">
                {{data.auth.pwdClearLabel}}
              </span>
            </small>
          </div>
          <div class="clearfix"></div>
          <small class="text-left" v-html="data.auth.authDisclaimer"></small>
          <div class="clearfix"></div>
          <!-- Successful login -->
          <alert class="alert alert-success" v-show="success">
            <span v-html="data.auth.pwdSuccess"></span>
          </alert>
          <!-- Failed login -->
          <alert class="alert alert-danger" v-show="alert">
            <span v-html="data.error.errorAuthText"></span>
          </alert>
        </div>
        <div class="col-sm"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from '../plugins/datocms'
import { showDelayText } from '../plugins/delayhandler'
import config from '../../config/index.js'
import Alert from '../../src/components/Alert'

export default {
  name: 'auth',
  components: {
    Alert
  },
  data () {
    return {
      data: null,
      password: '',
      alert: false,
      success: false,
      showOrHide: true,
      loginStarted: false
    }
  },
  methods: {
    auth () {
      let loader = this.$loading.show({
        default: showDelayText(this.data.auth.loginStarted, this.delayTimerReduced)
      })
      this.loginStarted = true
      this.alert = false
      this.success = false
      for (const [pharmacy, phrase] of Object.entries(this.data.auth.phrases)) {
        if (this.password === phrase) {
          setTimeout(() => {
            loader.hide()
            this.success = true
          }, this.authDelayDoubled)
          setTimeout(() => {
            localStorage.setItem('access', this.password)
            localStorage.setItem('pharmacy', pharmacy)
            this.$router.push('/login')
          }, this.authDelayExtended)
        }
      }
      if (!Object.values(this.data.auth.phrases).includes(this.password)) {
        setTimeout(() => {
          loader.hide()
          this.loginStarted = false
          this.alert = true
        }, this.authDelayDoubled)
      }
    },
    enterKeyHandler () {
      if (this.password && this.password.length >= 3) {
        this.auth()
      }
    },
    showPwd () {
      const pwd = document.getElementById('pwd')
      if (pwd.type === 'password') {
        pwd.type = 'text'
        this.showOrHide = false
      } else {
        pwd.type = 'password'
        this.showOrHide = true
      }
    },
    clearPwd () {
      if (this.password && this.password.length >= 3) {
        localStorage.removeItem('access')
        this.password = ''
      }
    },
    callAuthIfParamsPresent () {
      if (this.$route.query.access && this.$route.query.access.length > 0) {
        this.password = this.$route.query.access
        this.auth()
      }
    }
  },
  computed: {
    authDelayDoubled () {
      return config.authDelay * 2
    },
    authDelayExtended () {
      return config.authDelay * 2.5
    },
    delayTimerReduced () {
      return Math.round(config.delayTimer / 18)
    }
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          error(locale: ` + sessionStorage.getItem('language') + `) {
            errorAuthText
          }
          auth(locale: ` + sessionStorage.getItem('language') + `) {
            phrases
            authHeader
            pwdPlaceholder
            pwdEnterLabel
            pwdShowLabel
            pwdHideLabel
            pwdClearLabel
            pwdSuccess
            authDisclaimer
            loginStarted
          }
        }
      `
    })
    setTimeout(() => {
      let access = localStorage.getItem('access') ? localStorage.getItem('access') : ''
      this.password = access
      this.callAuthIfParamsPresent()
    })
  },
  updated () {
    this.$nextTick(function () {
      const access = localStorage.getItem('access')
      for (const phrase of Object.values(this.data.auth.phrases)) {
        if (access && access === phrase) {
          this.$router.push('/login')
          break
        }
      }
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
input:disabled {
  opacity: 0.7;
}
button:disabled {
  opacity: 0.3;
}
.btn-primary:not(:disabled):not(.disabled):hover {
  color: #fff !important;
  background: #2571ac !important;
}
.card {
  min-height: auto !important;
  background: #001965 !important;
  color: #fff !important;
}
small {
  font-size: .85em;
}
.card-clear-pwd {
  margin-top: .33em;
  padding: .5em;
}
.card-clear-pwd small {
  font-size: .65em;
}
.card-clear-pwd span:active {
  color: #4D5E93
}
.alert {
  padding: 1rem 0.5rem 0 .4rem !important;
  font-size: 0.6em !important;
}
.container {
  height: 100vh;
  background: rgb(209, 209, 209) !important;
  margin-top: 0 !important;
  padding-top: 15vh !important;
}
.logo {
  height: 80px;
  width: 120px;
  margin-bottom: 2vh;
  margin-left: .5vw;
}
#btn-ok:not(:disabled) {
  transform: scale(1);
  animation: pulse 2s infinite;
}
.disabled {
  pointer-events: none;
}
@keyframes pulse {
  0% {
    transform: scale(0.98);
    box-shadow: 0 0 0 0 rgba(15, 44, 67, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(15, 44, 67, 0.0);
  }

  100% {
    transform: scale(0.98);
    box-shadow: 0 0 0 0 rgba(15, 44, 67, 0.0);
  }
}

/* Portrait and Landscape */
@media only screen
  and (min-device-width: 300px)
  and (max-device-width: 812px) {
  .card {
    margin-bottom: 0 !important;
  }
  .container {
    margin-bottom: -6.5vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Auth.vue